<template>
    <section class="hero-section">
      <h1>蓉城·记忆</h1>
      <p class="pinyin">Rong Cheng Ji Yi</p>
      <h1>Gasthaus zur Linde</h1>
      <!-- <img src="../assets/menu_01.jpg" alt="餐馆特色菜" class="hero-image"> -->
    </section>
  </template>
  
  <script>
  export default {
    name: 'HeroSection',
  };
  </script>
  
  <style scoped>
  .hero-section {
    background-image: url('../assets/rc_Section.png'); 
  background-repeat: repeat; 
  background-position: left center;
   background-size: contain; 
    text-align: center;
    /* padding: 2rem 1rem; */
    padding: 12rem 1rem;
    /* background-color: #92861c;  可选：添加浅色背景 */
  }
  
  .hero-section h1 {
    font-size: 2.5rem; /* 更大的标题 */
    /* margin-bottom: 1.5rem; */
    margin-bottom: 0rem;
      color:#f0ebeb;
      line-height: 1.2; /* Adjust line height for h1 */
  }
  .hero-section h1:nth-child(3) {
    margin-top: 0.5rem;  /* Add a small top margin to the second h1 */
}
  
  .pinyin {
  font-size: 1rem; /* Pinyin font size */
  color: #f0ebeb;     /* Different color for pinyin */
  margin-bottom: 0rem;  /* Space between pinyin and the next h1 */
  margin-top: 0.25rem;
  line-height: 1;  /* Adjust line height for pinyin,  can be different from h1 */
}
  
  .hero-image {
    width: 100%;
    max-width: 100px; /* 控制图片最大宽度 */
    height: auto;
    display: block; /* 消除图片底部间隙 */
    margin: 0 auto; /* 水平居中 */
    border-radius: 8px; /* 可选：添加圆角 */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 可选：添加阴影 */
  }
    /*移动端*/
    @media(max-width: 768px){
        .hero-section{
            padding: 9rem 0.5rem;
        }
        .hero-section h1{
            font-size: 1.8rem;/*缩小字号*/
            margin-bottom: 0.5rem;
            line-height: 1.1; /* Adjust line-height on mobile */
        }
        .hero-section h1:nth-child(3){
      margin-top: 0.3rem;
    }
        .pinyin {
    font-size: 1rem; /* Smaller pinyin font size on mobile */
    margin-bottom: 0.3rem;
    margin-top: 0.1rem;
    line-height: 1; /* Adjust line-height for pinyin on mobile*/
  }
    }
  </style>